import { isModelSchema } from '../utils/utils';
/**
 * Returns the standard model schema associated with a class / constructor function
 *
 * @param {object} thing
 * @returns {ModelSchema} model schema
 */
export function getModelSchema(thing) {
    if (!thing)
        return null;
    if (typeof thing.serializeInfo === 'function') {
        // && isModelSchema(thing.serializeInfo())
        return { ...thing.serializeInfo(), constructor: thing };
    }
    if (isModelSchema(thing))
        return thing;
    if (isModelSchema(thing.serializeInfo))
        return { ...thing.serializeInfo, constructor: thing };
    if (thing.constructor && thing.constructor.serializeInfo && typeof thing.constructor.serializeInfo === 'function') {
        return { ...thing.constructor.serializeInfo(), constructor: thing.constructor };
    }
    if (thing.constructor && thing.constructor.serializeInfo) {
        return { ...thing.constructor.serializeInfo, constructor: thing.constructor };
    }
    return null;
}
